// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"0323eb19","326":"92755025","334":"6b7bb80f","411":"0c92aac9","976":"0a2f4abe"}[chunkId] + ".chunk.css";
};